/* Dozzz sticky-bar trust strip: appended after the buy box script runs.
   Kept as a separate tiny script so the main buy box logic stays untouched. */
(function () {
  const sb = document.querySelector('[data-dz-sticky]');
  const root = document.querySelector('.dz-buybox');
  if (!sb || !root) return;
  const FREE_QTY = parseInt(root.getAttribute('data-free-delivery-qty'), 10) || 2;
  let trust = sb.querySelector('.dz-sb-trust');
  if (!trust) {
    trust = document.createElement('div');
    trust.className = 'dz-sb-trust';
    sb.appendChild(trust);
  }
  const update = () => {
    const count = document.querySelectorAll('[data-dz-slots] .dz-slot').length || 0;
    const free = count >= FREE_QTY;
    trust.textContent = free
      ? '\u2713 Free next-day delivery unlocked \u00b7 100-night money-back guarantee'
      : '\u00a33.95 delivery \u00b7 2+ masks ship free next-day \u00b7 100-night guarantee';
  };
  update();
  new MutationObserver(update).observe(document.querySelector('[data-dz-slots]') || sb, { childList: true, subtree: true });
})();
